import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'

export const UPLOAD_AUDIO_FORM_ID = 'upload-audio-form'

const schema = z.object({
  name: z.string().min(1),
  description: z.string().optional(),
  file: z.instanceof(File),
})

export type UploadAudioFormValues = z.infer<typeof schema>
export const uploadAudioFormResolver = zodResolver(schema)
